import { useEffect, useState, type CSSProperties } from 'react';
import { Icon } from './Icon';
import { useAllClients, useWorkspace, useWorkspaces } from '../data/store';

export function WorkspaceSwitcher() {
  const { current, setCurrent } = useWorkspace();
  const clients = useAllClients();
  const workspaces = useWorkspaces();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  // A partner has a single workspace — no switcher to show. (After all hooks.)
  if (workspaces.length <= 1) return null;

  const label = current === 'all' ? 'Tutti gli spazi' : workspaces.find((w) => w.id === current)?.name ?? '';
  const count = (id: string) => clients.filter((c) => c.workspaceId === id).length;
  const pick = (id: string) => {
    setCurrent(id);
    setOpen(false);
  };

  return (
    <div className="ws-switch">
      <button type="button" className="ws-current" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
        <Icon name="building" size={13} />
        <span className="ws-current-label">{label}</span>
        <Icon name="cdown" size={13} />
      </button>

      {open && (
        <>
          <div className="ws-scrim" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="ws-menu">
            <button type="button" className={'ws-opt' + (current === 'all' ? ' on' : '')} onClick={() => pick('all')}>
              <span className="ws-opt-av all" aria-hidden="true">∗</span>
              <span className="ws-opt-name">Tutti gli spazi</span>
              <span className="ws-opt-count">{clients.length}</span>
            </button>
            <div className="ws-sep" />
            {workspaces.map((w) => (
              <button
                key={w.id}
                type="button"
                className={'ws-opt' + (current === w.id ? ' on' : '')}
                onClick={() => pick(w.id)}
              >
                <span className="ws-opt-av" style={{ '--av': w.accent } as CSSProperties} aria-hidden="true">
                  {w.mono}
                </span>
                <span className="ws-opt-name">{w.name}</span>
                <span className="ws-opt-count">{count(w.id)}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
